import type { Holiday } from './holiday.model';
import type { ReadEnvelope } from './read-envelope.model';

export type DayKind = 'work' | 'free' | 'holiday' | 'outside_employment';

export interface DayCalendarDay {
  date: string;
  dayKind: DayKind;
  locked: boolean;
  holiday: Holiday | null;
}

export interface DayCalendarResponse extends ReadEnvelope {
  personId: string;
  days: DayCalendarDay[];
  holidaysMissing: boolean;
  nextHoliday?: Holiday | null;
}
